<template>
	<div class="register_success">
    <div>
      <span class="register_success_link">
        <i class="iconfont icon-search"></i>
        https://www.fangcloud.com
      </span>
      <div class="register_success_div">
        <span class="register_close_1 confirm" @click="reloadPage()">我知道了</span>
        <span class="register_close_1" @click="copyLink()">复制链接</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RegisterSuccess',
  props: {

  },
  data () {

  },
  computed: {

  },
  watch: {
  },
  mounted () {

  },
  methods: {
    copyLink () {
      const textarea = document.createElement('textarea')
      textarea.setAttribute('readonly', 'readonly')
      textarea.value = 'https://www.fangcloud.com'
      document.body.appendChild(textarea)
      textarea.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      this.reloadPage()
    },
    reloadPage () {
      window.location.reload()
    }
  }
}
</script>
<style lang="postcss" scoped>
	@import 'variables';

  .register_success {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    top: 0;
    left: 0;

    & img {
      width: 80px;
      height: 64px;
      position: absolute;
      top: -28px;
      left: 50%;
      transform: translateX(-50%);
    }

    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 362px;
      height: 420px;
      position: fixed;
      margin: auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      box-sizing: border-box;
      background: url('https://p3.ssl.qhimg.com/t11b673bcd6724fae93f381ec0f.png') center center no-repeat;
      padding-top: 280px;
      background-size: 100%;
    }

    & .register_success_text {
      color: #1B2532;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }

    & .register_success_link {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 294px;
      height: 48px;
      color: #000;
      font-feature-settings: 'clig' off, 'liga' off;
      font-family: "PingFang SC";
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      border-radius: 24px;
      background: #EDF1F5;

      & i {
        color: #1A65FF;
        margin-right: 5px;
        position: relative;
        left: -2px;
        font-weight: normal;
      }
    }

    & .register_success_div {
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      & span {
        display: flex;
        width: 139px;
        height: 40px;
        justify-content: center;
        align-items: center;
        color: #FFF;
        font-feature-settings: 'clig' off, 'liga' off;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        border-radius: 4px;
        border: 1px solid #006BFF;
        background: #006BFF;

        &.confirm {
          color: #1B2532;
          border: 1px solid #D8E0E8;
          background: #FFF;
          margin-right: 16px;
        }
      }
    }
  }
</style>
